import Vue from "vue";
import VueMask from 'v-mask';
// @ts-ignore
Vue.use(VueMask);